{
	"title": "Erklärung erstellen",
	"backLinkToMaterialDetailsTitle": "Zurück zu Materialdetails",
	"backLinkToMaterialDetailsWithDescriptionTitle": "Zurück zu {{materialDescription}}",
	"backLinkToManageDeclarationsTitle": "Zurück zu Erklärungen verwalten",
	"steps": {
		"firstStep": {
			"title": "Schritt 1",
			"label": "1"
		},
		"secondStep": {
			"title": "Schritt 2",
			"label": "2"
		},
		"thirdStep": {
			"title": "Schritt 3",
			"label": "3"
		}
	}
}
